export const addClassToDefaultIfDefined = (defaultClass, classToAdd) =>
  classToAdd ? `${defaultClass} ${classToAdd}` : defaultClass;
